<template>
  <h1
    class="truncate text-center text-lg font-semibold text-headline sm:text-left sm:text-2xl"
  >
    <slot></slot>
  </h1>
</template>
